module.exports = __webpack_public_path__ + "static/favicon-52c4bac0e646236e17f7052d305ff294.png";